import BODYMAP from '@/module/util/get-bodymap'
import formatDateTime from '@/module/util/format-date-time'

const month_short_name = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
// Number of symptoms to display before only showing the title
const DISPLAY_THRESHOLD = 5

export function displayChartingAnswer(question, answer, patient, responseDate) {
    try {
        if(!answer)
            return ''
        if(question.type === 'text' && answer && answer[0] == null)
            return ''

        let displayAns = ''

        let TranslationObj = {
            "FirstName" : patient.given_name,
            "LastName": patient.family_name,
            "ResponseDate": `<b>${responseDate}</b>`,
            "ResponseValue": displayAnswer(question, answer),
            "ResponseTranslation": ""
        }

        if(question.type === "multi_question")
            TranslationObj["ResponseTranslation"] = ""
        else if (question.type === "long_text_bubble") {
            TranslationObj["ResponseTranslation"] = answer.reduce((translationAcc, answerObj) => {
                const answeredOption  = question.options.find(({ id }) => answerObj.id === id)
                translationAcc += translationAcc.length > 0 ?  ', ' : ''
                if(answeredOption)
                    return translationAcc + answeredOption.charting_translation
                return translationAcc + answerObj.display_text
            }, '')
            // Adds non selection translations
            let answeredIds = Object.keys(answer).map(idx => answer[idx].id)
            let unselectedTranslations = Object.keys(question.options).filter(idx => !answeredIds.includes(question.options[idx].id))
                                        .filter(idx => question.options[idx].hasOwnProperty('charting_non_selection_translation') && question.options[idx].charting_non_selection_translation)
                                        .map(idx => question.options[idx].charting_non_selection_translation)
            if (TranslationObj["ResponseTranslation"].length && unselectedTranslations.length)
                TranslationObj["ResponseTranslation"] += ', '
            TranslationObj["ResponseTranslation"] += unselectedTranslations.join(', ')
        }
        else if(question.type === 'human_map') {
            if(!question.charting_translation && !question.charting_non_selection_translation)
                TranslationObj["ResponseTranslation"] = displayAnswer(question, answer)

            if(question.charting_translation)
                TranslationObj["ResponseTranslation"] = answer.map((ansValue) => question.charting_translation[ansValue]).join(', ')

            if(question.charting_non_selection_translation) {
                // iterate through question options
                // if option not found in answer array && has non selection value 
                // then add non selection translation to TranslationObj as well
                let unselectedTranslations = Object.keys(question.charting_non_selection_translation).filter(option => !answer.includes(option))
                                        .filter(option => question.charting_non_selection_translation.hasOwnProperty(option) && question.charting_non_selection_translation[option])
                                        .map(option => question.charting_non_selection_translation[option])
                if (TranslationObj["ResponseTranslation"].length && unselectedTranslations.length)
                    TranslationObj["ResponseTranslation"] += ', '
                TranslationObj["ResponseTranslation"] += unselectedTranslations.join(', ')
            }
        }
            

        else if (Object.keys(question.charting_translation).length === 0) 
            TranslationObj["ResponseTranslation"] = displayAnswer(question, answer)

        else if (question.type === 'binary')
            TranslationObj["ResponseTranslation"] =  answer[0] === 'Yes' ? question.charting_translation[0] : question.charting_translation[1]

        else if (question.type === 'radio') {
            TranslationObj["ResponseTranslation"] = question.charting_translation[answer - 1]
            TranslationObj["ResponseValue"] = answer
        }

        else if (Array.isArray(answer)) {
            TranslationObj["ResponseTranslation"] = answer.reduce((translationAcc, answerValue) => {
                try {
                    const optionIndex = question.option.indexOf(answerValue)

                    translationAcc += translationAcc.length > 0 ?  ', ' : ''
                    if(optionIndex === -1)
                        return translationAcc + answerValue
                    return translationAcc + question.charting_translation[optionIndex]
                } catch (error) {
                    console.error('Problem getting option', error)
                    return translationAcc
                }

            }, '')

            if (question.type === 'select') {
                // filters selected options, keeps only unselected options
                // if non selection translation present for that option then adds it Translation object
                let unselectedTranslations = question.option.filter(option => !answer.includes(option))
                                            .filter(option => question.charting_non_selection_translation && question.charting_non_selection_translation[question.option.indexOf(option)])
                                            .map(option => question.charting_non_selection_translation[question.option.indexOf(option)])
                if (TranslationObj["ResponseTranslation"].length && unselectedTranslations.length)
                    TranslationObj["ResponseTranslation"] += ', '
                TranslationObj["ResponseTranslation"] += unselectedTranslations.join(', ')
            }
        }
        else {
            TranslationObj["ResponseTranslation"] =  Object.keys(answer).reduce((translationAcc, answerKey, currentIndex) => {
                if(translationAcc.length > 0)
                    translationAcc +=  ', '
                return translationAcc + question.charting_translation[answerKey]
            }, '')

            if (['box_select', 'large_image_select', 'small_image_select'].includes(question.type)) {
                // filters selected options, keeps only unselected options
                // if non selection translation present for that option then adds it Translation object
                let unselectedTranslations = Object.keys(question.select).filter(option => !Object.keys(answer).map(k => k).includes(option))
                                            .filter(option => question.charting_non_selection_translation && question.charting_non_selection_translation[parseInt(option)])
                                            .map(option => question.charting_non_selection_translation[parseInt(option)])
                if (TranslationObj["ResponseTranslation"].length && unselectedTranslations.length)
                    TranslationObj["ResponseTranslation"] += ', '
                TranslationObj["ResponseTranslation"] += unselectedTranslations.join(', ')
            }

            if(question.type === 'slider' || question.type === 'scroller')
                TranslationObj["ResponseValue"] = Object.values(answer)[0]
        }

        if(Array.isArray(TranslationObj["ResponseValue"]))
            TranslationObj["ResponseValue"] = TranslationObj["ResponseValue"].join(', ')

        TranslationObj["ResponseTranslation"] = '<b>' + TranslationObj["ResponseTranslation"] + '</b>'
        TranslationObj["ResponseValue"] = '<b>' + TranslationObj["ResponseValue"] + '</b>'

        if(question.type === 'multi_question') {
            displayAns = translateAnswer(question.charting_template, TranslationObj)
            displayAns += answer.reduce((translationAcc, answer) => {
                const questionOption = question.questions.find(({ id }) => id === answer.id)
                if(answer.answer.length == 0)
                    return translationAcc

                TranslationObj["ResponseTranslation"] = `<b>${answer.answer[0].answer.trim()}</b>`
                TranslationObj["ResponseValue"] = `<b>${answer.answer[0].answer.trim()}</b>`
                if(questionOption) {
                    return translationAcc + ' ' + translateAnswer(questionOption.charting_template, TranslationObj)
                }
                    
                return translationAcc
            }, '')
        }
            
        else {
            // console.log(translateAnswer(question.charting_template, TranslationObj))
            displayAns = translateAnswer(question.charting_template, TranslationObj)
        }
        return displayAns
    } catch (error) {
        console.error(error, question, answer)
        return displayAnswer(question, answer)
    }
    
}

function translateAnswer(chartingTemplate, TranslationObj) {
    if(!chartingTemplate)
        return ''
    const MatchRegex = /{{(.[^}}]*)}}/g
    return chartingTemplate.match(MatchRegex) ? chartingTemplate.match(MatchRegex)
        .reduce((matchAcc, translationMatch) => {
            const replaceWith = translationMatch.slice(2, -2).trim()
            return matchAcc.replace(translationMatch, TranslationObj[replaceWith])
        }, chartingTemplate)
        : chartingTemplate
}




export function displayAnswer(question, answer) {

    if (Array.isArray(answer)) {
        if(question.type === 'multi_question') {
            return question.questions.map((option) => {
                const answerOption = answer.find((ansObj) => ansObj.id === option.id)
                // If answer doesn't exist then return with `null`
                if(!answerOption)
                    return null
                return ((option.title ? option.title : '[Question Title]') + ' : ' + (answerOption ? answerOption.answer[0].answer : ''))
            })
            .filter((answer) => answer)
            .join('\n' + (question.title ?  ` ${question.title} :  ` : '' ))
        }
        else if(question.type === 'long_text_bubble') {
            return answer.map((ansObj) => ansObj.display_text).join(', ')
        }
        else if(question.type === 'human_map') {
            return answer.map((bodyPart) => BODYMAP[bodyPart] ? BODYMAP[bodyPart].name : '').join(', ')
        }
        else if (question.type === 'sign_document') {
            if(answer[0] && answer[0].image_url) {
                return 'Signed - ' + formatDateTime(answer[0].meta.device_time)
            } else {
                return 'Not Answered'
            }
        }
        else if (question.type === 'date') {
            if(answer[0]) {
                if(answer[0].date) {
                    return month_short_name[answer[0].month - 1] + ' ' + ((answer[0].date < 9) ? ' 0' + answer[0].date : answer[0].date) + ', ' + answer[0].year
                } else {
                    return month_short_name[answer[0].month - 1] + ', ' + answer[0].year
                }
            } else {
                return 'Not Answered'
            }
        }
        else if(question.type === 'unit') {
            if(answer[0]) {
                return answer[0].answer + ' ' + answer[0].display_text
            }
        }
        else if(question.type === 'select') {
            return answer.map((ansValue) => question.option.includes(ansValue) ? ansValue : `"${ansValue}"` ).join(', ')
        }
        return answer.join(', ')
    }
    if (question.type === 'radio') {
        return answer
    }
    if (answer != null && typeof answer === 'object') {
        
        var nullValue = false
        Object.keys(answer).forEach((a) => {
            if (answer[a] == null)
                nullValue = true
        })

		if (question.type === 'star') {
            let index = parseInt(Object.keys(answer)[0])
			return (index + 1) + ' star' + (question.label[index] ? (' (' + question.label[index] + ')') : '')
		}

		else if (question.type === 'radio') {
			return answer
        }
        
        else if(question.type === 'image_upload') {
            if(answer.image_url)
                return 'Image Added ' + (answer.image_description ? `( ${answer.image_description.trim()} )` : '')
            else
                return answer.image_description
        }

        else if (question.type === 'slider' || question.type === 'scroller') {
			let min = question.min || 1,
				max = question.max || 10
			let start = question.label[min - 1],
				end = question.label[max - 1]

			let k = Object.keys(answer)[0]
			let n = parseInt(k) + 1
			let v = answer[k]

			if (start && start != min)
				start += ' (' + min + ')'
			if (end && end != max)
				end += ' (' + max + ')'

			if (start && end)
				return n + ', between ' + start + ' and ' + end
			else if (start)
				return n + ', scale from ' + start
			else if (end)
				return n + ', scale up to ' + end
            return v || n
        }
		else if (nullValue) {
            if(question.type === 'text')
                return answer[0] ? answer[0].trim() : ''
            return Object.keys(answer).join(', ')
        }
        else if (question.type === 'text')
            return answer[0] ? answer[0].trim() : ''
        else
            return Object.keys(answer).map((k) => answer[k])
    }
    else
        return ''
}

export default function(patient, questionnaires, analytics) {
    var result = []
    let sortedQuestionnaire  = questionnaires.filter((questionnaire) => questionnaire.completed)
    sortedQuestionnaire.forEach((questionnaire) => {
        let id = questionnaire.type.split(':')[1]
        let questionnaireResult = {
            result : [],
            id: questionnaire.id,
            emrCategory: questionnaire.emrCategory ? questionnaire.emrCategory : [],
            integration: questionnaire.integration,
            lastPushed: questionnaire.lastPushed
        }
        let content = this.getContent('questionnaire', id)

        if (content && questionnaire.completed && Array.isArray(questionnaire.question)) {
            questionnaireResult.time = this.formatDate(questionnaire.completed, false, true)
            questionnaireResult.displayTime = this.formatDate(questionnaire.completed)
            
            questionnaireResult.title = content.display_name || content.title
            questionnaireResult.questionnaire_id = content.id
            if(analytics && analytics[questionnaire.id]) {
                questionnaireResult.result = analytics[questionnaire.id].result
                questionnaireResult.questions_responses = analytics[questionnaire.id].questions_responses
                if(analytics[questionnaire.id].question_emrs && Object.keys(analytics[questionnaire.id].question_emrs).length) {
                    questionnaireResult.question_emrs = analytics[questionnaire.id].question_emrs
                }
            }
            else {
                questionnaireResult.result = 'Loading Results...'
            }
            result.push(questionnaireResult)
            

            //For header and footer
            // let TranslationObj = {
            //     "FirstName" : patient.given_name,
            //     "LastName": patient.family_name,
            //     "ResponseDate": `<b>${questionnaireResult.time}</b>`,
            //     "Age": patient.birthdate ? parseInt((new Date()  - new Date(patient.birthdate)) / (365 * 24 * 60 * 60 * 1000)) : 'N/A'
            // }
            // content.question.forEach((question, index) => {
            //     let response = questionnaire.question.find((response) => (response != null && response.id == question.id))
                
            //     // mapping title for header and footer
            //     TranslationObj['Q' + (index + 1) + 'Title'] = question.title ? question.title : 'N/A'


            //     if (response != null && typeof response === 'object' && Object.keys(response).length > 0) {
            //         let validResponse = response.answer || response.value
            //         if(question.type === 'image_upload') {
            //             if(response.image_description || response.image_url)
            //                 validResponse = { image_description : response.image_description, image_url: response.image_url }
            //             else
            //                 return
            //         }
            //         let isMultiCharting = false
            //         if(question.type == 'multi_question')
            //             isMultiCharting = question.charting_template || question.questions.some((subQ) => subQ.charting_template)
            //         let answer = (question.charting_template || isMultiCharting) ?
            //             displayChartingAnswer(question, validResponse, patient, questionnaireResult.time) + ' ' :
            //             `${question.title || (index + 1)} : <b>${displayAnswer(question, validResponse)}</b>\n`
            //         questionnaireResult.result.push(answer)

            //         // mapping response for header and footer
            //         TranslationObj['Q' + (index + 1) + 'Response'] = Array.isArray(displayAnswer(question, validResponse)) ? displayAnswer(question, validResponse).join(' ') : displayAnswer(question, validResponse)
            //     } else {
            //         TranslationObj['Q' + (index + 1) + 'Response'] = 'N/A'
            //     }
            // })

            // questionnaireResult.result = (content.charting_header ? translateAnswer(content.charting_header, TranslationObj) : '')
            //     + questionnaireResult.result.join('')
            //     + (content.charting_footer ? translateAnswer(content.charting_footer, TranslationObj) : '')

            // result.push(questionnaireResult)
        }
    })

    return result
}
